import { NgIf, NgSwitch, NgSwitchCase, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';

import { HelpArticlesDirective } from '@recruitee/help-articles';
import { TranslatePipe } from '@recruitee/i18n';
import { PersonalTokenDataModule } from '@recruitee/personal-token/data';
import {
  BadgeComponent,
  ButtonComponent,
  DialogBodyComponent,
  DropdownItemComponent,
  HeadingComponent,
  IconComponent,
  PlanButtonComponent,
  SidebarItemComponent,
} from '@recruitee/user-interface';

import { FeatureButtonComponent } from './feature-button/feature-button.component';
import { FeatureGuardButtonComponent } from './feature-guard-button/feature-guard-button';
import { FeaturePlanIconColorDirective } from './feature-guard-button/feature-plan-icon-color.directive';
import { FeatureGuardContentComponent } from './feature-guard-content/feature-guard-content.component';
import { FeatureGuardDialogComponent } from './feature-guard-dialog/feature-guard-dialog.component';
import { FeatureGuardDropdownItemComponent } from './feature-guard-dropdown-item/feature-guard-dropdown-item.component';
import { FeatureGuardElementDirective } from './feature-guard-element/feature-guard-element.directive';
import { FeatureGuardEmptyComponent } from './feature-guard-empty/feature-guard-empty.component';
import { FeatureGuardSidebarItemComponent } from './feature-guard-menu-item/feature-guard-sidebar-item.component';
import { FeatureGuardFacade } from './feature-guard.facade';
import { FeaturesGuardModel } from './feature-guard.model';

@NgModule({
  imports: [
    BadgeComponent,
    ButtonComponent,
    DialogBodyComponent,
    DropdownItemComponent,
    HeadingComponent,
    HelpArticlesDirective,
    IconComponent,
    PersonalTokenDataModule,
    PlanButtonComponent,
    SidebarItemComponent,
    TranslatePipe,
    NgIf,
    NgSwitch,
    NgSwitchCase,
    NgTemplateOutlet,
  ],
  providers: [FeatureGuardFacade, FeaturesGuardModel],
  declarations: [
    FeatureGuardButtonComponent,
    FeatureGuardDropdownItemComponent,
    FeatureGuardSidebarItemComponent,
    FeatureGuardDialogComponent,
    FeatureButtonComponent,
    FeatureGuardContentComponent,
    FeatureGuardEmptyComponent,
    FeatureGuardElementDirective,
    FeaturePlanIconColorDirective,
  ],
  exports: [
    FeatureGuardButtonComponent,
    FeatureGuardSidebarItemComponent,
    FeatureGuardDropdownItemComponent,
    FeatureGuardContentComponent,
    FeatureGuardElementDirective,
    FeaturePlanIconColorDirective,
  ],
})
export class FeatureGuardModule {}

export {
  FeatureGuardFacade,
  FeatureGuardButtonComponent,
  FeatureGuardSidebarItemComponent,
  FeatureGuardDropdownItemComponent,
  FeatureGuardContentComponent,
  FeatureGuardElementDirective,
  FeatureGuardDialogComponent,
  FeatureGuardEmptyComponent,
  FeaturePlanIconColorDirective,
};

export { FeatureGuardGuard } from './feature-guard.guard';
export * from './feature-guard.model';
export * from './feature-guard.types';

export { PricingAnalyticsFeature, PricingAnalyticsService } from './pricing-analytics.service';
